export default __webpack_public_path__ + "static/tillys_video_testimonial-b7778c5aa083b7779e9a01e8c21bf77e.mp4";